import React, { createContext, useContext, useEffect, useState } from "react";
import { api, resolveUrl } from "../lib/api";

const SiteImagesContext = createContext({ overrides: {}, simg: (k, f) => f });

export function SiteImagesProvider({ children }) {
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    let mounted = true;
    api.get("/site-images")
      .then((res) => {
        if (!mounted) return;
        const raw = res.data || {};
        const resolved = {};
        Object.keys(raw).forEach((k) => { resolved[k] = resolveUrl(raw[k]); });
        setOverrides(resolved);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  // resolve an image slot key to an uploaded override or fall back to the default
  const simg = (key, fallback) => overrides[key] || fallback;

  return (
    <SiteImagesContext.Provider value={{ overrides, simg }}>
      {children}
    </SiteImagesContext.Provider>
  );
}

export function useSiteImages() {
  return useContext(SiteImagesContext);
}
